import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Form, Row, Col, FormControl, Button, Alert } from 'react-bootstrap';

import './Login.sass';

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studentId: '',
      groupId: '',
    };
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this.refs.studentIdField).focus();
  }

  clearForm = () => {
    this.setState({
      studentId: '',
      groupId: '',
    });
  };

  handleStudentIdChange = (e) => {
    this.setState({ studentId: e.target.value });
  };

  handleGroupIdChange = (e) => {
    this.setState({ groupId: e.target.value });
  };

  login = (e) => {
    e.preventDefault();
    this.props.handleLogin(this.state.studentId, this.state.groupId);
    this.clearForm();
  };

  renderTitle = () => {
    if (this.props.loading) {
      return (
        <h4>
          Loading... <i className="fa fa-spin fa-spinner" />
        </h4>
      );
    } else {
      return <h4></h4>;
    }
  };

  render() {
    const { message, loading } = this.props;
    return (
      <div className="login-modal">
        <TransitionGroup component={null}>
          <CSSTransition
            key="login"
            classNames="login"
            timeout={{ appear: 1000, enter: 1000, exit: 500 }}
          >
            <Form onSubmit={this.login}>
              <img
                src={process.env.PUBLIC_URL + '/img/wbl_logo_new_big.png'}
                alt="WhiteBox Learning"
                width="368"
                height="120"
                className="mb-3"
              />
              {message.length ? (
                <Alert variant="danger">Login failed.</Alert>
              ) : (
                this.renderTitle()
              )}
              <Form.Group as={Row} controlId="_studentId" className="my-2">
                <Form.Label column sm={4}>
                  Student Id
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    ref="studentIdField"
                    value={this.state.studentId}
                    onChange={this.handleStudentIdChange}
                    type="password"
                    disabled={loading}
                    placeholder="Student ID"
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="_groupId" className="my-2">
                <Form.Label column sm={4}>
                  Group Id
                </Form.Label>
                <Col sm={8}>
                  <FormControl
                    value={this.state.groupId}
                    onChange={this.handleGroupIdChange}
                    type="text"
                    disabled={loading}
                    placeholder="Group ID"
                  />
                </Col>
              </Form.Group>

              <Button type="submit" disabled={loading} className="btn-block">
                Login
              </Button>
            </Form>
          </CSSTransition>
        </TransitionGroup>
      </div>
    );
  }
}

Login.propTypes = {
  handleLogin: PropTypes.func.isRequired,
  message: PropTypes.string,
  loading: PropTypes.bool,
};

Login.defaultProps = {
  message: '',
  loading: false,
};
